import React, { useRef, useState } from "react";
import { tabLocations } from "../data/mockData";
import LocationCard from "./LocationCard";

const LocationsCarousel = ({ activeTab, onExploreMap, onLocationClick }) => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const data = tabLocations[activeTab] || tabLocations["New Apartments"];

  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir === "right" ? 220 : -220, behavior: "smooth" });
    }
  };

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  };

  return (
    <section className="py-8 border-b border-gray-100" aria-label="Top locations">
      <div className="container mx-auto px-4 md:px-6 ">
        <h2 className="text-base md:text-3xl font-semibold text-gray-700 mb-5 py-12">
          {data.title}
        </h2>

        <div className="relative">
          {canScrollLeft && (
            <button
              onClick={() => scroll("left")}
              className="absolute -left-4 top-[80px] -translate-y-1/2 bg-white border border-gray-200 rounded-full w-9 h-9 flex items-center justify-center shadow-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 z-10"
              aria-label="Scroll left"
            >
              <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          )}

          <div
            ref={scrollRef}
            onScroll={handleScroll}
            className="flex gap-4 overflow-x-auto pb-1"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
            role="list"
            aria-label="Location cards"
          >
            {data.cards.map((loc) => (
              <div key={loc.id} role="listitem">
                <LocationCard
                  image={loc.image}
                  title={loc.title}
                  onClick={loc.isMap && onExploreMap ? onExploreMap : () => onLocationClick(loc.title.toLowerCase())}
                />
              </div>
            ))}
          </div>

          {canScrollRight && (
            <button
              onClick={() => scroll("right")}
              className="absolute -right-4 top-[80px] -translate-y-1/2 bg-white border border-gray-200 rounded-full w-9 h-9 flex items-center justify-center shadow-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 z-10"
              aria-label="Scroll right"
            >
              <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default LocationsCarousel;
